import type { MaybeRefOrGetter } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IDepartmentItem, IGetDepartmentsResponse } from '../types';
import {
  AFFILIATES_APPROVED_PERMISSIONS,
  AFFILIATES_DEPARTMENT_LIST_QUERY_KEY,
  AFFILIATES_DEPARTMENT_LIST_URL,
} from '../constants';

export default function useAffiliatesDepartmentListQuery(enabled: MaybeRefOrGetter<boolean | undefined> = true): IContextQueryResult<
  IGetDepartmentsResponse,
  Error,
  IDepartmentItem[]
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IGetDepartmentsResponse, Error, IDepartmentItem[]>({
    queryKey: [AFFILIATES_DEPARTMENT_LIST_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<IGetDepartmentsResponse>(
      AFFILIATES_DEPARTMENT_LIST_URL,
      {
        signal,
        permission: AFFILIATES_APPROVED_PERMISSIONS.UPDATE_DEPARTMENT_FOR_AFFILIATES,
      },
    ),
    enabled,
    select: (data) => data.list,
  });
}
